"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');








/*
 * Identifies the one message that should play an entrance animation.
 *
 * A message earns an entrance only when it is genuinely *new to a thread the
 * user is already looking at* — sent, or received over the socket. Everything
 * else has to be excluded, because animating it would put motion in front of
 * work the user is waiting on:
 *
 *  - the initial batch, which arrives all at once when a chat is opened. The
 *    thread must paint at full opacity on the first frame; that is the single
 *    most latency-sensitive moment in the app.
 *  - pagination, which prepends older messages above the viewport.
 *  - batch switching (jumping to the latest messages from a deep link), which
 *    swaps the whole list.
 *
 * All three are ruled out by the same test: an entrance requires that the
 * previous newest message is still present and the new message sits directly
 * above it in sequence. Anything that replaces the list wholesale fails it.
 *
 * The previous newest is held in state and adjusted during render rather than
 * in a ref. Render has to stay pure — React is free to replay or discard a
 * render pass, and a ref written during one that never commits would leak,
 * quietly consuming a message's one chance to animate. Adjusting state during
 * render is the supported way to derive a value from a change in inputs: React
 * throws away this pass and immediately re-runs the component, so nothing extra
 * is committed or painted. This function also returns the freshly computed key
 * on the same pass, so the class is correct even before that re-run.
 *
 * An effect would be the wrong tool here: it runs after commit, so the message
 * would paint unstyled and only then start animating — reintroducing exactly
 * the perceived latency this animation is meant to avoid.
 */
const useEnteringMessage = (
  messages,
  hasSettledScroll,
) => {
  const [seen, setSeen] = _react.useState(null)
  const [entering, setEntering] = _react.useState(null)

  const newest = _nullishCoalesce(messages[0], () => ( null))
  const newestKey = _nullishCoalesce(_optionalChain([newest, 'optionalAccess', _ => _.MessageKey]), () => ( null))

  if (!hasSettledScroll) {
    // Still opening the conversation. Track the newest message so the first
    // arrival after settling is measured against it, but never animate.
    if (newest && _optionalChain([seen, 'optionalAccess', _2 => _2.key]) !== newestKey) {
      setSeen({ key: newest.MessageKey, sequence: newest.Sequence })
    }
    if (entering !== null) setEntering(null)
    return null
  }

  if (newest && newestKey !== _optionalChain([seen, 'optionalAccess', _3 => _3.key])) {
    const isAppendToSameList = !!seen &&
      newest.Sequence === seen.sequence + 1 &&
      messages.some(m => m.MessageKey === seen.key)
    const next = isAppendToSameList ? newest.MessageKey : null

    setSeen({ key: newest.MessageKey, sequence: newest.Sequence })
    setEntering(next)
    return next
  }

  return entering
}

exports. default = useEnteringMessage
